module.exports = __webpack_public_path__ + "components/MapControl/svg/Kapliczka.svg?7115176a";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Kapliczka.svg
// module id = 1942
// module chunks = 0